"use client"
import { memo } from "react";
import OverlayTransitionWrapper from "@/components/overlay-transition-wrapper/overlay-transition-wrapper";
import StoriesPage from "@/components/stories/stories-page";
import StoryFormLayout from "@/components/story-form/story-form-layout";

function StoryPage({ ugcStories }) {
  return (
    <OverlayTransitionWrapper
      backgroundContent={
        <StoriesPage ugcStories={ugcStories} isDummy={true} />
      }
      overlayContent={
        <div className="w-full font-sans page">
          <StoryFormLayout/>
        </div>
      }
      mainContent={
        <div className="w-full font-sans page">
          <StoryFormLayout/>
        </div>
      }
    />
  )
}

export default memo(StoryPage)
